import Store, { ReducerKeys } from "../reducers";
import { path } from "ramda";
import { isAlive, ArrayUtil } from "./index";

export const Roles = {
	User:"user",
	Admin:"admin",
	SuperAdmin:"superadmin",
	OrganizationAdmin:"organization_admin",
	OrganizationSuperAdmin:"organization_superadmin",
};

export default {
	/**
     * Check if 
     * @param {string} categoryname 
     */
	isCategoryExists(categoryName){
		const org = path([ReducerKeys.ORGANIZATION, "organization"], Store.getState());
		if(!isAlive(org)){
			return false;
		}
		const orgKeys = Object.keys(org);
		const catKeys = orgKeys.filter(k=>k.toLowerCase().startsWith("category") && isAlive(org[k]));
		return catKeys.findIndex(k=>isAlive(k) && org[k].toLowerCase()===categoryName.toLowerCase()) !== -1;
	},
	getCategoryNameByID(id){
		const org = path([ReducerKeys.ORGANIZATION, "organization"], Store.getState());
		if(isAlive(org)){
			const orgKeys = Object.keys(org);
			const catKeys = orgKeys.filter(k=>k.toLowerCase().startsWith("category"));
			return org[catKeys[id-1]];
		}
		return "Unname Category";
	},
	getIdOfCategoryName(categoryName){
		const allCat = Array.from(this.getAllCategoryName(), n=>n.toLowerCase());
		const index = allCat.indexOf(categoryName.toLowerCase());
		if(index!==-1){
			return index+1;
		}
		return index;
	},
	getAllCategoryName(){
		const infos = this.getAllCategoryInfoFromState(Store.getState());
		if(ArrayUtil.isAliveArray(infos)){
			return Array.from(infos,i=>i.name);
		}
		return [];
	},
	getAllCategoryInfo(){
		return this.getAllCategoryInfoFromState(Store.getState());
	},
	getAllCategoryInfoFromState(state){
		const org = path([ReducerKeys.ORGANIZATION, "organization"], state);
		if(isAlive(org)){
			const orgKeys = Object.keys(org);
			const catKeys = orgKeys.filter(k=>k.toLowerCase().startsWith("category"));
			const infos = [];
			catKeys.forEach((v,i)=>{
				if(isAlive(org[v])){
					const choice = path([`choice${i+1}`,"data"],org);
					infos.push({name:org[v], id:(i+1), choice});
				}
			});
			return infos;
		}
		return [];
	},
	getChoicesOfCategoryID(id){
		const org = path([ReducerKeys.ORGANIZATION, "organization"],Store.getState());
		return path([`choice${id}`, "data"],org);
	},
	/**
     * Get category choice by category name.
     * @param {string} categoryName 
     */
	getChoicesOfCategory(categoryName){
		const org = path([ReducerKeys.ORGANIZATION, "organization"],Store.getState());
		const orgKeys = Object.keys(org);
		const catKeys = orgKeys.filter(k=>k.toLowerCase().startsWith("category"));
		const catIndex = catKeys.findIndex(k=>isAlive(k) && isAlive(org[k]) && org[k].toLowerCase()===categoryName.toLowerCase());
		if(catIndex!==-1){
			return this.getChoicesOfCategoryID(catIndex+1);
			// return path([`choice${catIndex+1}`, 'data'],org);
		}
		return undefined;
	},
	/**
     * Get category item name by id.
     * @param {number} id 
     */
	getCategoryItemNameByID(categoryName,id){
		const categoryChoices = this.getChoicesOfCategory(categoryName) || [];
		if(categoryChoices.length > 0){
			const target = categoryChoices.find((d=>d.id===id));
			if(isAlive(target)){
				return target.name;
			}
		}
		return undefined;
	},
	/**
     * Get category item id by name
     * @param {string} category
     * @param {string} name 
     */
	getCategoryIdByName(category, name){
		const catChoices = this.getChoicesOfCategory(category) || [];
		if(catChoices.length > 0){
			const target = catChoices.find((d=>d.name.toLowerCase()===name.toLowerCase()));
			if(isAlive(target)){
				return target.id;
			}
		}
		return -1;
	},
	/**
     * Convert age range string to number array
     * @param {string} ageString 
     */
	toAgeRangeArray(ageString){
		let range = [1, 200];
		if(ageString.indexOf("-") !== -1){
			range = Array.from(ageString.split("-"), age=>parseInt(age,10));
		}else if(ageString.endsWith("+")){
			range = [parseInt(ageString.substring(0, ageString.length-1),10), range[1]];
		}else{
			range = [range[0], parseInt(ageString,10)];
		}
		return range;
	}
};


// WEBPACK FOOTER //
// ./src/util/organize.js